"use strict";
function isObject(x) {
    return x != null && typeof x === 'object';
}
exports.isObject = isObject;
//# sourceMappingURL=isObject.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2032928750/src/~/rxjs/util/isObject.js
// module id = H6Sg
// module chunks = 6